import React from 'react'

export default function RadioWaveRings({
  className = '',
  sizes = ['h-16 w-16', 'h-32 w-32', 'h-56 w-56'],
  ringColorClasses = ['border-neon-300/50', 'border-neon-300/30', 'border-neon-300/15'],
}) {
  const delays = ['0s', '0.6s', '1.2s']

  return (
    <div className={`pointer-events-none ${className}`} aria-hidden="true">
      {sizes.map((size, i) => (
        <span
          key={size}
          className={`absolute inset-0 m-auto ${size} animate-ping rounded-full border ${ringColorClasses[i]}`}
          style={{ animationDelay: delays[i] }}
        ></span>
      ))}
    </div>
  )
}
